import { Component } from '../core/Component';

/**
 * Visual representation of an entity.
 */
export class Sprite extends Component {
  /** Phaser texture key */
  texture: string = '';
  /** Optional frame name or index */
  frame?: string | number;
  /** Width override (uses texture size if not set) */
  width?: number;
  /** Height override (uses texture size if not set) */
  height?: number;
  /** Anchor point X (0-1, default center) */
  originX: number = 0.5;
  /** Anchor point Y (0-1, default center) */
  originY: number = 0.5;
  /** Visibility */
  visible: boolean = true;
  /** Alpha/opacity (0-1) */
  alpha: number = 1;
  /** Depth/z-index for render order */
  depth: number = 0;
  /** Tint color (0xRRGGBB) */
  tint?: number;
}
